export default __webpack_public_path__ + "f5459674cca3bd2ba9db04b1382b273f.svg";